import { apiDelete, apiGet, apiPost, apiPut } from '@/services/api/apiClient';
import { API_ENDPOINTS } from '@/constants/endpoints';
import {
  Facility,
  FacilityFormData,
  FacilityListParams,
  FacilityListResponse,
  ApiResponse,
} from '@/constants/types';

class FacilityService {
  async list(params: FacilityListParams): Promise<FacilityListResponse> {
    try {
      const queryParams = new URLSearchParams();
      if (params.sortDir) queryParams.append('sortDir', params.sortDir);
      if (params.limit !== undefined) queryParams.append('limit', params.limit.toString());
      if (params.offset !== undefined) queryParams.append('offset', params.offset.toString());
      if (params.search_string !== undefined) queryParams.append('search_string', params.search_string);
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);

      const url = `${API_ENDPOINTS.FACILITIES.LIST}?${queryParams.toString()}`;
      const response = await apiGet<FacilityListResponse>(url, { showLoader: true });
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to fetch facilities');
    }
  }

  async add(data: FacilityFormData): Promise<ApiResponse<Facility>> {
    try {
      const response = await apiPost<ApiResponse<Facility>>(
        API_ENDPOINTS.FACILITIES.ADD,
        data,
        { showLoader: true, backdrop: false }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to add facility');
    }
  }

  async update(id: string, data: FacilityFormData): Promise<ApiResponse<Facility>> {
    try {
      const response = await apiPut<ApiResponse<Facility>>(
        API_ENDPOINTS.FACILITIES.UPDATE(id),
        data,
        { showLoader: true, backdrop: false }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to update facility');
    }
  }

  async delete(facilityId: string): Promise<ApiResponse> {
    try {
      const response = await apiDelete<ApiResponse>(
        API_ENDPOINTS.FACILITIES.DELETE,
        { facility_id: facilityId },
        { showLoader: true, backdrop: false }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to delete facility');
    }
  }
}

export const facilityService = new FacilityService();
